module.exports = __webpack_public_path__ + "img/banco-safra.982e2822.svg";